import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function navigatePostSaveBundle(setLocation?: (path: string) => void) {
  if (typeof window === "undefined") return;

  const isImp =
    localStorage.getItem("isImpersonating") === "true" ||
    Boolean(JSON.parse(localStorage.getItem("user") || "{}").isImpersonating) ||
    Boolean(localStorage.getItem("adminToken"));

  if (isImp) {
    const adminToken = localStorage.getItem("adminToken");
    if (adminToken) {
      localStorage.setItem("token", adminToken);
      localStorage.removeItem("adminToken");
    }
    localStorage.removeItem("isImpersonating");
    localStorage.removeItem("user");

    let adminUrl = process.env.REACT_APP_ADMIN_URL || "";
    if (!adminUrl) {
      const host = window.location.hostname;
      const currentPort = window.location.port;
      const isLocalHostOrIp = host === "localhost" || host === "127.0.0.1" || /^(?:\d{1,3}\.){3}\d{1,3}$/.test(host);
      if (isLocalHostOrIp) {
        const targetPort = currentPort === '3001' ? '3000' : '3001';
        adminUrl = `${window.location.protocol}//${host}:${targetPort}/dashboard`;
      } else {
        adminUrl = `${window.location.protocol}//${host}/admin/dashboard`;
      }
    }
    if (!adminUrl) adminUrl = "https://straightdoc.info/admin/dashboard";

    if (window.opener && !window.opener.closed) {
      try { window.opener.focus(); } catch (e) {}
      window.close();
    } else {
      window.location.href = adminUrl;
    }
  } else if (setLocation) {
    setLocation("/provider/bundles");
  } else {
    window.location.href = "/provider/bundles";
  }
}
